(ns manage.slate-editor.codec
  (:require ["slate" :as slate]
            [clojure.string :as str]
            [manage.slate-editor.common :as common]
            [manage.slate-editor.util :as util]))

(defn- text-parser [text]
  [{:text text}])

(defn- macro-parser [is-macro-valid?]
  (fn [text next-parser]
    (->> text
         (util/re-partition-indexed (common/macro-node-regex))
         (mapcat (fn [{:keys [text match]}]
                   (if (nil? text)
                     (let [[[_macro-index _macro-text] [_content-text-index content-text]] match]
                       [{:type     common/macro-node-type
                         :children [{:text "${"}
                                    {:type     common/macro-content-node-type
                                     :children (next-parser content-text)}
                                    {:text "}"}]
                         :isValid (is-macro-valid? content-text)}])
                     (next-parser text))))
         vec)))

(defn- mentions-parser [allowed-mentions-id]
  (fn [text next-parser]
    (->> text
         (util/re-partition-indexed (common/mentions-node-regex))
         (mapcat (fn [{:keys [text match]}]
                   (if (nil? text)
                     (let [[[_mention-idx mention-text] [_mention-id-index mention-id]] match]
                       (if (allowed-mentions-id (js/parseInt mention-id))
                         [{:type     common/mention-node-type
                           :id       (js/parseInt mention-id)
                           :children [{:text "@"}
                                      (first (next-parser mention-id))]}]
                         (next-parser mention-text)))
                     (next-parser text))))
         vec)))

(defn- query-param-parser [text next-parser]
  (->> text
       (util/re-partition-indexed (common/query-param-node-regex))
       (mapcat (fn [{:keys [text match]}]
                 (if (nil? text)
                   (let [[_outer-query-param [_attribute-index attribute-text] [_value-index value-text]] match]
                     [{:type     common/query-param-node-type
                       :children [{:text ""}
                                  {:type     common/query-param-attribute-node-type
                                   :children (next-parser attribute-text)}
                                  {:text "="}
                                  {:type     common/query-param-value-node-type
                                   :children (next-parser value-text)}
                                  {:text ""}]}])
                   (next-parser text))))
       vec))

(defn- paragraph-parser [text next-parser]
  (-> text
      (str/split #"\n|\r\n" -1) ; Do NOT use str/split-lines as the empty trailing lines will be ignored.
      (->> (mapv (fn [text]
                   {:type "paragraph"
                    :children (next-parser text)})))))

(defn- compose-parsers [parsers]
  (->> parsers
       (filterv some?)
       rseq
       (reduce (fn [next-parser parser]
                 (fn [text]
                   (parser text next-parser))))))

(defn text->slate-value
  "Converts a plain text into a Slate data model."
  [text {:keys [allow-query-params allow-macros is-macro-valid? allow-mentions allowed-mentions-ids]}]
  (let [parse (compose-parsers [paragraph-parser
                                (when allow-query-params query-param-parser)
                                (when allow-macros (macro-parser is-macro-valid?))
                                (when allow-mentions (mentions-parser allowed-mentions-ids))
                                ;; Always keep this parser at the end.
                                text-parser])]
    (parse text)))

(defn slate-value->text
  "Converts a Slate data model into a plain text."
  [^js slate-value]
  (->> slate-value
       (map slate/Node.string)
       (str/join "\n")))
